import React from "react"
import styled from "styled-components"

const Description = styled.div`
  font-size: 17px;
  width: 80%;
  margin: 0 auto;
  margin-top: 40px;
  padding-top: 40px;
  border-top: 0.5px solid gray;
  padding-bottom: 60px;
`

class DescriptionSection extends React.Component {
  render() {
    return (
      <>
        <Description>{this.props.description.about.about}</Description>
      </>
    )
  }
}

export default DescriptionSection
